import classNames from "classnames"
import { initializeCenterModalForComponentAction } from "features/content-overlay/slice"
import { usePaywalls } from "features/entity-caching/licenses/useLicensePaywall"
import { useAppDispatch } from "integrations/redux/hooks"
import Image from "next/image"
import { FeaturePlugin } from "plugins/plugin-registry"
import * as Icons from "@nova/component-icons"

export const TryAddOnItem = ({
    plugin,
    blockedMessage,
}: {
    plugin: Omit<FeaturePlugin, "type">
    blockedMessage?: string
}) => {
    const dispatch = useAppDispatch()
    const { showAddOnPaywallModal } = usePaywalls()

    return (
        <div
            className={classNames(
                "rounded-lg border py-3 px-4 transition-colors duration-150 cursor-pointer flex gap-3 items-center group",
                "border-gray-700",
                { "hover:border-lazeryellow hover:bg-gray-900": !blockedMessage },
                { "active:border-gray-0 active:bg-black-900": !blockedMessage }
            )}
            onClick={
                !blockedMessage
                    ? () =>
                          dispatch(
                              initializeCenterModalForComponentAction(plugin.sampleDataModalName!)
                          )
                    : !!plugin.subscriptionType
                      ? () => showAddOnPaywallModal(plugin.subscriptionType!)
                      : undefined
            }
        >
            <div className="w-5 h-5">
                <Image
                    src={plugin.iconUrl}
                    alt={plugin.displayName}
                    width={24}
                    height={24}
                    className={classNames("w-full h-full object-contain", {
                        "saturate-0 opacity-50": !!blockedMessage,
                    })}
                    priority
                />
            </div>

            <h4 className={classNames("text-gray-0", { "opacity-50": !!blockedMessage })}>
                {plugin.displayName}
            </h4>

            {blockedMessage && (
                <small className="xs text-gray-300 group-hover:hidden whitespace-nowrap ml-auto">
                    {blockedMessage}
                </small>
            )}

            <Icons.SmallIcon
                Icon={Icons.ArrowRight}
                className={classNames(
                    "opacity-0 group-hover:opacity-100 text-gray-300 group-active:text-gray-0 ml-auto",
                    { "hidden group-hover:flex": !!blockedMessage }
                )}
            />
        </div>
    )
}
